
import {ISelectItem} from "winfakt-vue-components";
import {Validatable} from "winfakt-vue-components/src/mixins/validatable";
import { Dossier } from "@/models/dossier";

export default Validatable.extend({
	props: {
		value: Number,
		dossiers: [],
		companyId: Number,
		label: String,
		fancy: Boolean,
		disabled: Boolean
	},
	computed: {
		items(): ISelectItem<number>[] {

			if(!this.dossiers){
				return [];
			}

			return (this.dossiers as Dossier[]).map(d => {
				return {
					text: d.name,
					value: d.id
				};
			});
		}
	},
	methods: {
		onInput(val:number) {
			this.$emit("input", val);
		}
	},
	async mounted(){
		//this.dossiers = await CompanyDossierService.getDossiers(this.companyId);
	}
});
